import {post} from '../utils'
import {makeFormData} from './utils'
import {getActiveHome} from "../authentication/utils";

export default host => ({
    title,
    subtitle,
    translations,
    description,
    imageFile,
    visibility,
    selectedContent,
    orderType
  }) =>
  post(`${host}/${getActiveHome() ? "home/" : ""}playlists`, makeFormData({
    title,
    subtitle,
    translations,
    description,
    imageFile,
    visibility,
    selectedContent,
    orderType
  }))
  .then(response => response.json())